import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bot } from 'lucide-react';
import { authApi, getAdminToken, setAdminToken, settingsApi } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

export default function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  React.useEffect(() => {
    if (getAdminToken()) {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      if (token.trim()) {
        setAdminToken(token.trim());
        await settingsApi.get();
        navigate('/', { replace: true });
        return;
      }
      const response = await authApi.login(username.trim(), password);
      const accessToken = response.data?.access_token;
      if (!accessToken) {
        setError('Сервер не выдал токен');
        return;
      }
      setAdminToken(accessToken);
      navigate('/', { replace: true });
    } catch (err) {
      setAdminToken('');
      const detail = err.response?.data?.detail;
      if (err.response?.status === 503) {
        setError(detail || 'Авторизация на сервере не настроена');
      } else {
        setError('Неверный логин, пароль или токен');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4" data-testid="login-page">
      <form onSubmit={handleSubmit} className="w-full max-w-md card">
        <div className="card-header">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-[#2AABEE]/10 flex items-center justify-center">
              <Bot className="w-6 h-6 text-[#2AABEE]" />
            </div>
            <div>
              <h1 className="card-title">Вход в SubPay</h1>
              <p className="text-xs text-zinc-500">Админ-панель закрыта. Учётные данные задаются на сервере.</p>
            </div>
          </div>
        </div>
        <div className="card-content space-y-4">
          <div>
            <Label htmlFor="admin-username">Логин</Label>
            <Input
              id="admin-username"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              data-testid="admin-username"
            />
          </div>
          <div>
            <Label htmlFor="admin-password">Пароль</Label>
            <Input
              id="admin-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password"
            />
          </div>
          <div>
            <Label htmlFor="admin-token">Или bearer-токен</Label>
            <Input
              id="admin-token"
              type="password"
              autoComplete="off"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              placeholder="BOT_ADMIN_TOKEN"
              data-testid="admin-token"
            />
          </div>
          {error && (
            <p className="text-sm text-red-400" data-testid="login-error">{error}</p>
          )}
          <Button type="submit" className="w-full bg-[#2AABEE] hover:bg-[#229ED9]" disabled={submitting} data-testid="login-submit">
            {submitting ? 'Вход...' : 'Войти'}
          </Button>
        </div>
      </form>
    </div>
  );
}
